module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAABGdBTUEAALGPC/xhBQAAAS1JREFUOBHt1D9LQlEYx3FPBNYgOejs4CCBWwQpQoY4CSG4trfX2DtoaXeRlv6s0tCgqPUGRBCXNt1Ch6Zo8PT9XTwXFb1wdx/4cM557sNzuAfOMZGlsNYesMzhAmX00UbPGPPN6Ae1hkUWqj3FvSGZZnK1SJ4xRjHH3tJomQ/xiSmOcY4EXO1thGZN/KKFO+RRheIZGVzjBT9Q9PGAS8Qxx42avQs7+MG6AsWTn2TC+tXLWnu4lvea6VfChH5pa4RttrWRPuyaBR7Pxo+7M9t4LIHJsGcWWL/vtuLOpZgXoSelBIUu8htjZ0HPjuKIvGqKUL3yf3qCdMn1drldv5h3MUISKj6BNnbPjRtn5HrQZg0VPGKMD3R4BCeMK8GGMRIF1JBHHWowoN4yevEP4QilaBGCFuwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/MapToolbar/icon-map-views.png
// module id = 1474
// module chunks = 0